package one.healthium.profile.navigation.update_height

import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.lifecycle.viewmodel.compose.LocalViewModelStoreOwner
import one.healthium.profile.ui.update_height.UpdateHeightScreen

@Composable
fun UpdateHeightContent(component: UpdateHeightComponent) {
    CompositionLocalProvider(
        LocalViewModelStoreOwner provides component
    ) {
        UpdateHeightScreen(component)
    }
}